/**
 * 社内IDとログイン用メールの相互変換(2026-09-03)。
 *
 * ログインは「社内ID」で行う。Firebase Auth はメールアドレスで人を見分けるため、
 * 内部では `<社内ID>@<固定ドメイン>` を使う。
 * 本人の連絡先メールアドレス(users.contact_email)とは別物なので混同しないこと。
 */
export const LOGIN_ID_DOMAIN = (import.meta.env.VITE_LOGIN_ID_DOMAIN as string | undefined) ?? 'example.com';

/** 入力された社内IDを整える。スペース(半角・全角)は混入なので取り除く(2026-09-10 指示) */
export function normalizeLoginId(loginId: string): string {
  return (loginId ?? '').replace(/\s/g, '').toLowerCase();
}

/** 社内ID → ログイン用メール(内部用) */
export function loginIdToEmail(loginId: string): string {
  return `${normalizeLoginId(loginId)}@${LOGIN_ID_DOMAIN}`;
}

/** ログイン用メール → 社内ID(画面表示用) */
export function emailToLoginId(email: string): string {
  return (email ?? '').split('@')[0] ?? '';
}

/** 社内IDとして使える文字か(英小文字・数字・ハイフン・ドット・アンダースコア) */
export function isValidLoginId(loginId: string): boolean {
  return /^[a-z0-9][a-z0-9._-]{1,63}$/.test(normalizeLoginId(loginId));
}
